<template>
  <div>
    <v-container fluid>
      <v-row class="pb-1">
        <v-col cols="3">
          <date-range :from.sync="from" :to.sync="to" v-model="dateDisplay" @change="refresh()" option="Last 30 days" hide-details/>
        </v-col>
        <v-col cols="2">
          <v-autocomplete label="Show customer" dense outlined :items="['Name','Type','Category']" v-model="by" hide-details @change="refresh()"/>
        </v-col>
        <v-col cols="2">
          <v-select label="Source" hide-details outlined dense v-model="source" :items="[{text:'Shipments',value:'shipment'},{text:'Invoices',value:'invoice'},{text:'Sales orders',value:'salesOrder'}]"  @change="refresh()"/>
        </v-col>
        <v-col cols="2">
          <v-switch label="Exclude $0 sales" hide-details dense class="mt-1" v-model="exclude0" @change="refresh()"/>
        </v-col>
        <v-col class="text-right pr-2">
          <v-btn icon @click="printHtml('Sales by customer', report())"><v-icon>mdi-printer</v-icon></v-btn>
          <v-tooltip bottom open-delay="1000" v-if="company.allowCSVExport">
            <template v-slot:activator="{on}">
              <v-btn icon @click="exportCSV" v-on="on"><v-icon>mdi-download</v-icon></v-btn>
            </template>
            Export as CSV file
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 228px)">
      <span v-html="report()"/>
    </v-card>
  </div>
</template>

<script>
import fileSaver from 'file-saver';
import printHtml from '@/mixins/printHtml'
import createHierarchyList from '@/mixins/createHierarchyList'

export default {
  name: 'ReportsSalesByCustomerItem',
  mixins: [printHtml,createHierarchyList],
  data() {
    return {
      by: 'Name',
      from: null,
      to: null,
      exclude0: false,
      source: 'shipment',
      dateDisplay: '',
      loading: true,
      totalRevenue: 0,
      totalCOG: 0,
      totalProfit: 0,
      totalMargin: 0,
      lines: []
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    }
  },
  async created() {
    this.$emit('name', 'Sales by customer/item')

    if (this.$route.query.from && this.$route.query.to) {
      this.from = this.$route.query.from;
      this.to = this.$route.query.to;
    }
  },
  methods: {
    async refresh() {
      this.loading = true;
      const results = await this.$apiCall(`query ReportsSalesByCustomerItem($from:Date!,$to:Date!, $exclude0:Boolean, $source:String!, $by:String) {
                                              salesReportByCustomerItem(from:$from,to:$to,exclude0:$exclude0,source:$source,by:$by) {
                                                name,item
                                                quantity,revenue,cog,profit,margin
                                              }
                                            }`,
                                          {from:this.from,to:this.to,exclude0:this.exclude0,source:this.source,by:this.by});
      if (!results.error) {
        this.lines = results.data.salesReportByCustomerItem;

        this.totalRevenue = 0;
        this.totalCOG = 0;
        this.totalProfit = 0;
        for (const line of this.lines) {
          this.totalRevenue += line.revenue;
          this.totalCOG += line.cog;
          this.totalProfit += line.profit;
        }
        this.totalMargin = this.totalRevenue == 0 ? 0 : this.totalProfit / this.totalRevenue * 100;
      }
      this.loading = false;
    },

    report() {
      const lines = [
                  `<style>
                    @page {size:landscape}
                    .report {font-family: Roboto, sans-serif; width:100%;border-spacing:0;font-size:12px}
                    .report th {height:36px;padding:0 16px;vertical-align:middle}
                    .report .spacer {height:18px}
                    .report td {height:36px;padding:0 16px;vertical-align:middle}
                    .report .title {font-size:18px;text-transform:uppercase}
                    .report .sup-title {font-weight:normal;font-size:22px}
                    .report .sub-title {font-weight:normal;height:inherit;padding-bottom:20px;font-size:14px}
                    .report .header th {border-bottom:1px solid #000;margin-bottom:20px}
                    .report .text-left {text-align:left}
                    .report .text-right {text-align:right}
                    .report .font-weight-bold {font-weight:bold}
                    .report .indent {text-indent:20px}
                    .report .total-row {font-weight:bold}
                  </style>
                   <table class="report">
                     <thead>
                        <tr>
                          <th colspan="6" class="sup-title">${this.company.name}</th>
                        </tr>
                        <tr>
                          <th colspan="6" class="title">Sales by customer/item</th>
                        </tr>
                        <tr>
                           <th colspan="6" class="sub-title">${this.dateDisplay}</th>
                        </tr>
                        <tr class="header">
                          <th width="28%" class="text-left">Customer ${this.by!=='Name'?this.by:''}/Item</th>
                          <th width="12%" class="text-right">Qty</th>
                          <th width="15%" class="text-right">${this.source === 'salesOrder' ? 'Amount' : 'Revenue'}</th>
                          ${this.source === 'invoice' || this.source === 'salesOrder' ? ``
                                              : `<th width="15%" class="text-right">COG</th>
                                                 <th width="15%" class="text-right">Gross profit</th>
                                                 <th width="15%" class="text-right">Margin</th>`}
                        </tr>
                      </thead>
                      <tbody>`
      ];
      let subTotal = {customer:null, revenue:0, cog:0};
      for (const line of this.lines) {
        if (line.name !== subTotal.customer) {
          if (subTotal.customer)
            this.subTotal(lines, subTotal);
          lines.push(`<tr><td colspan="${this.source === 'shipment' ? 5 : 2}">${line.name}</td></tr>`);
          subTotal = {customer:line.name, revenue:0, cog:0};
        }
        subTotal.revenue += line.revenue; subTotal.cog += line.cog;
        lines.push(`<tr>
                    <td class="indent">${line.item}</td>
                    <td class="text-right">${line.quantity}</td>
                    <td class="text-right">$${this.$number(line.revenue,2)}</td>`);
        if (this.source === 'shipment')
          lines.push(`<td class="text-right">$${this.$number(line.cog,2)}</td>
                      <td class="text-right">$${this.$number(line.profit,2)}</td>
                      <td class="text-right">${this.$number(line.margin,1)}%</td>`);
        lines.push(`</tr>`);
      }
      if (subTotal.customer)
        this.subTotal(lines, subTotal);
      lines.push(`<tr class="total-row">
                  <td class="text-right" colspan="2">Total</td>
                  <td class="text-right">$${this.$number(this.totalRevenue,2)}</td>`);
      if (this.source === 'shipment')
        lines.push(`<td class="text-right">$${this.$number(this.totalCOG,2)}</td>
                    <td class="text-right">$${this.$number(this.totalProfit,2)}</td>
                    <td class="text-right">${this.$number(this.totalMargin,1)}%</td>`);
      lines.push(`</tr></tbody>`);
      lines.push(`</table>`);
      return lines.join('');
    },

    subTotal(lines, subTotal) {
      lines.push(`<tr class="total-row"><td/><td/><td class="text-right">$${this.$number(subTotal.revenue,2)}</td>`);
      if (this.source === 'shipment') {
        const profit = subTotal.revenue - subTotal.cog;
        lines.push(`<td class="text-right">$${this.$number(subTotal.cog,2)}</td>
                    <td class="text-right">$${this.$number(profit,2)}</td>
                    <td class="text-right">${this.$number(profit/subTotal.revenue*100,1)}%</td>`);
      }
      lines.push(`</tr>`);
    },

    exportCSV() {
      const lines = [ `"${this.company.name}"`,
                      `"Sales by customer/item"`,
                      `"${this.dateDisplay}"`
                    ];
      lines.push(this.source !== 'shipment' ? `"Customer ${this.by!=='Name'?this.by:''}","Item","Qty","Revenue"` : `"Customer ${this.by!=='Name'?this.by:''}","Item","Qty","Revenue","COG","Gross profit","Margin"`);
      for (const line of this.lines) {
        if (this.source !== 'shipment')
          lines.push(`"${line.name}","${line.item}","${line.quantity}","${this.$number(line.revenue,2)}"`);
        else
          lines.push(`"${line.name}","${line.item}","${line.quantity}","${this.$number(line.revenue,2)}","${this.$number(line.cog,2)}","${this.$number(line.profit,2)}","${this.$number(line.margin,1)}"`);
      }

      // Write CSV file
      const blob = new Blob([lines.join('\r\n')], {type: "text/plain;charset=utf-8"});
      fileSaver.saveAs(blob, 'Sales by customer.csv');
    }
  }
}
</script>